<template>
  <div class="sc-typing-indicator"
       :class="{ 'indent': indent }"
       :style="messageColors"
  >
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>
<script>

export default {
  props: {
    messageColors: {
      type: Object,
      required: true
    },
    indent: {
      type: Boolean,
      default: false
    }
  }
}
</script>
